import api from '../index';

export type UpdateContentSubmissionAnalysisPayload = {
  analysisRating?: number | null;
  analysisNote?: string | null;
};

const contentSubmissionAnalysisUpdaters = {
  update: async (
    id: string,
    payload: UpdateContentSubmissionAnalysisPayload
  ) => {
    return api.put(`/content_submission_analyses/${id}`, payload);
  },
};

export default contentSubmissionAnalysisUpdaters;
